import { UserBuilder } from '../../../../common/users/user-builder';
import { ItemType } from '../../../../common/misc/item-type.enum';
import { IVRJourneyEventType } from './ivr-journey-event-type.enum';
import { RandomGenerator } from '../../../../../test-utils';
var IVRJourneyEventBuilder = /** @class */ (function () {
    function IVRJourneyEventBuilder() {
        this.phoneCallEvent = {
            id: RandomGenerator.randomId(),
            itemId: RandomGenerator.randomId(),
            itemType: ItemType.PHONE_CALL,
            eventType: IVRJourneyEventType.INCOMING_CALL,
            user: new UserBuilder().build(),
            creationDate: Date.now(),
            infoValues: {
                item_title: { DATA: RandomGenerator.randomString() },
                journeyItemId: { DATA: RandomGenerator.randomId() },
                journeyText: { DATA: RandomGenerator.randomString() }
            }
        };
    }
    IVRJourneyEventBuilder.prototype.withId = function (id) {
        this.phoneCallEvent.id = id;
        return this;
    };
    IVRJourneyEventBuilder.prototype.withItemId = function (itemId) {
        this.phoneCallEvent.itemId = itemId;
        return this;
    };
    IVRJourneyEventBuilder.prototype.withEventType = function (eventType) {
        this.phoneCallEvent.eventType = eventType;
        return this;
    };
    IVRJourneyEventBuilder.prototype.withUser = function (user) {
        this.phoneCallEvent.user = user;
        return this;
    };
    IVRJourneyEventBuilder.prototype.withCreationDate = function (creationDate) {
        this.phoneCallEvent.creationDate = creationDate;
        return this;
    };
    IVRJourneyEventBuilder.prototype.withInfoValues = function (infoValues) {
        this.phoneCallEvent.infoValues = infoValues;
        return this;
    };
    IVRJourneyEventBuilder.prototype.build = function () {
        return this.phoneCallEvent;
    };
    return IVRJourneyEventBuilder;
}());
export { IVRJourneyEventBuilder };
//# sourceMappingURL=ivr-journey-event.builder.js.map